import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { useSharedTranslation } from "@/shared/contexts/TranslateContext";

import Button from "../Button";
import IconView from "../../IconView/IconView";
import EgwWebFont from "../../../assets/EgwWebFont";
import IconButton from "@/shared/components/IconButton/IconButton";

import styles from "./close-button.module.scss";

const CloseButton = ({ className, showLabel = true, ...props }) => {
  const { t } = useSharedTranslation();

  if (showLabel) {
    return (
      <Button
        variant={Button.variant.clear}
        color={Button.color.icon}
        className={classnames(styles["btn-close"], className)}
        {...props}
      >
        <IconView icon={EgwWebFont.close} />
        {showLabel && <span className={styles["btn-close__text"]}>{t("hideBtn")}</span>}
      </Button>
    );
  }

  return (
    <IconButton
      className={classnames(styles["root-icon-btn"], className)}
      icon={EgwWebFont.close}
      title={t("hideBtn")}
      {...props}
    />
  )
};

CloseButton.size = Button.size;

CloseButton.propTypes = {
  showLabel: PropTypes.bool,
  className: PropTypes.string
};

export default CloseButton;
